import {AfterViewInit, Directive, ElementRef, OnChanges, OnInit, Renderer2, SimpleChanges} from '@angular/core';
import {Router} from '@angular/router';

@Directive({
  selector: '[customNavCollapse]',
  standalone: true
})
export class NavCollapseDirective implements OnInit, OnChanges, AfterViewInit {

  currentUrl: string = undefined;

  constructor(public elementRef: ElementRef, private router: Router, private renderer: Renderer2) {
    this.currentUrl = this.router?.url;
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngAfterViewInit(): void {

  }

  ngOnInit(): void {
    setTimeout(() => {
      let list = this.elementRef.nativeElement.querySelectorAll('[data-bs-toggle="collapse"]');
      list.forEach((toggler: any, key: any) => {
        let dataBsTarget = toggler.getAttribute('data-bs-target');
        let collapsedElement = document.querySelector(`${dataBsTarget}`);
        let childrenActiveList = document.querySelectorAll(`${dataBsTarget} a.active`);
        if (childrenActiveList.length) {
          // toggler.classList.add('active');
          toggler.classList.add('collapsed');
          collapsedElement.classList.add('show');
          toggler.setAttribute('aria-expanded', 'true');
        } else {
          // toggler.classList.remove('active');
          toggler.classList.remove('collapsed');
          collapsedElement.classList.remove('show');
          toggler.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }
}
